<template>
    <div v-if="secteur" :style="{ width: width + 'px' }" class="bulle">
        <span v-if="secteur.entreprises" class="countCompaniesInBubble">{{ secteur.entreprises.length }}</span>
        <h2 v-if="secteur.x_name" class="sectorTitle">{{ secteur.x_name }}</h2>
    </div>
</template>

<script>

export default {
  name: 'Bubble',
  props: ['secteur', 'minEntreprise', 'maxEntreprise', 'domain'],
  data: function () {
    return {
        width: 0,
        minWidth: 115,
        maxWidth: 400,
        nbrEntreprise: 0,
    }
  },
  mounted() {
    this.calculWidth() 
  },
  updated() {
    this.calculWidth()
  },
  methods: {
    calculWidth() {
      if (this.secteur['entreprises'] && this.maxEntreprise != this.minEntreprise) {
        this.nbrEntreprise = this.secteur['entreprises'].length
        this.width = (((this.maxWidth - this.minWidth) / (this.maxEntreprise - this.minEntreprise)) * (this.nbrEntreprise - this.minEntreprise)) + this.minWidth
      } else if(this.maxEntreprise == this.minEntreprise) {
         this.width = this.minWidth
      }
       else {
        this.width = this.minWidth
      }
    },
  }
}
</script>

<style scoped>
.bulle {
  min-height: 140px;
  margin: 15px;
  text-align: center;
  background-color: #12204c;
  border-radius: 60px;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  border-top: 3px solid #ff0033;
  box-shadow: 1px 2px 2px rgb(175, 175, 175);
  padding: 15px;
  position: relative;
  justify-content: center;
}

.bulle:hover {
  box-shadow: 5px 7px 7px rgb(175, 175, 175);
}

.sectorTitle {
  margin: 19px auto !important;
  font-size: 15px !important;
  color: white;
  line-height: 1.3 !important;
}

.countCompaniesInBubble{
  position: absolute;
  right: 22px;
  top: 16px;
  font-size: 12.5px;
  font-weight: bolder;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
